import React, { useContext, useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import SideMenuItem from './SideMenuItem'
import RolePermissionContext from '../../context/RolePermissionContext'

interface Props {
  asideMenuClasses: string[]
}

const skipKeys = [
  'Form-Builder',
  'Resume-Parser',
  'IBot-Assistant',
  'Document-Managament-System',
  'Bussiness-Process-Automation',
  'Optical-Character-Recongnition'
]

const SideMenuList: React.FC<Props> = ({ asideMenuClasses }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const { data2 } = useContext(RolePermissionContext)
  const [sidePanelItems, setSidePanelItems] = useState<any[]>([])

  useEffect(() => {
    if (!!data2) {
      const permissions = data2?.getModuleAcessByRole?.data || []
      console.log(permissions)

      // Map permissions to menu items
      const menuArray = permissions
        .filter((permission: any) => permission.isAccess && permission.module.sideMenu?.to)
        .map((permission: any) => ({
          key: permission.module.name,
          ...permission
        }))

      // Sort by the 'order' property
      menuArray.sort((a: any, b: any) => a.order - b.order)

      setSidePanelItems(menuArray)
    }
  }, [data2])

  return (
    <div className='aside-menu flex-column-fluid'>
      <div id='kt_aside_menu_wrapper' ref={scrollRef} className='my-5 my-lg-5'>
        <div
          id='kt_aside_menu'
          className={clsx(
            'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500',
            asideMenuClasses.join(' ')
          )}
        >
          {sidePanelItems.length > 0 &&
            sidePanelItems.map((item) => {
              if (!skipKeys.includes(item.key) && item.module.sideMenu) {
                // Accessing properties from item.module.sideMenu
                return (
                  <SideMenuItem
                    key={item.key}
                    to={item.module.sideMenu.to}
                    icon={item.module.sideMenu.icon}
                    title={item.module.sideMenu.title}
                    children={undefined}
                  />
                )
              }
              return null
            })}

          {/* <SideMenuItem
            key={10}
            to='/learning'
            icon='/media/icons/duotune/social/soc009.svg'
            title='eLearning'
            children={undefined}
          /> */}
          {/* <SideMenuItem
            key={10}
            to='/ai-bots'
            icon='/media/icons/duotune/social/soc009.svg'
            title='AI Botbuilder'
            children={undefined}
          /> */}
          {/* <SideMenuItem
            key={11}
            to='/files-assets'
            icon='/media/icons/duotune/technology/teh008.svg'
            title='Chatbot Detector'
            children={undefined}
          /> */}
        </div>
      </div>
    </div>
  )
}

export default SideMenuList
